import { render, staticRenderFns } from "./FireComplaintFiledModal.vue?vue&type=template&id=5aad9e6d&scoped=true"
import script from "./FireComplaintFiledModal.vue?vue&type=script&lang=ts"
export * from "./FireComplaintFiledModal.vue?vue&type=script&lang=ts"
import style0 from "./FireComplaintFiledModal.vue?vue&type=style&index=0&id=5aad9e6d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aad9e6d",
  null
  
)

export default component.exports